import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { config } from '../../config/configurations';

export const fetchInstanceData = createAsyncThunk(
  'initialization/fetchInstanceData',
  async (_, { rejectWithValue }) => {
    try {
      const baseURL: string =
        import.meta.env.VITE_URL_BACKEND_API || config.REACT_APP_URL_BACKEND_API;

      try {
        const response = await axios.get(`${baseURL}/init`);
        if (response.status === 200) {
          return response.data;
        }
        throw new Error('Failed to fetch from primary endpoint');
      } catch (error) {
        const env = import.meta.env.VITE_ENVIRONMENT;
        if (env?.toLowerCase() === 'development') {
          const resp = await axios.get('https://api.staging.sbrain.io/init');
          if (resp.status === 200) {
            return resp.data;
          }
        }
        throw error;
      }
    } catch (error) {
      return rejectWithValue('Unable to fetch instance data');
    }
  },
);
